module.exports = __webpack_public_path__ + "static/GavulaXMas--2020-5cc803e563fc2c4313a4bc221e636fee.pdf";